import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { FprTemplateListComponent } from './fpr-template-list/fpr-template-list.component'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatRadioModule } from '@angular/material/radio'
import { Router, RouterModule } from '@angular/router'
import { TranslationService } from '../../../services/translation.service'

@Component({
  selector: 'app-fpr-templates',
  imports: [
    RouterModule,
    MatExpansionModule,
    MatRadioModule,
    FprTemplateListComponent,
  ],
  templateUrl: './fpr-templates.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './fpr-templates.component.scss',
})
export class FprTemplatesComponent {
  translationService = inject(TranslationService)
  router = inject(Router)

  goToCreate() {
    this.router.navigate(['settings', 'fpr-templates'])
  }
}
